/**
 * Custom scripts for the theme.
 */

// Swym init
function swymCallbackFn(swat) {
  document.addEventListener("swym:collections-loaded", function () {
    swat.initializeActionButtons("body");
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

// handle the toggle button for the mobile nav drawer menu
const $drawerMenuToggle = document.querySelectorAll(".drawer-menu__toggle");
$drawerMenuToggle.forEach((toggle) => {
  toggle.addEventListener("click", (e) => {
    e.preventDefault();

    const $parentListItem = toggle.closest(".drawer-menu__item");
    const $subMenu = $parentListItem.querySelector(".drawer-menu__toggle-list");

    // toggle the active class on the button
    toggle.classList.toggle("is-active");

    // update toggle button aria attributes
    const openTranslation = toggle.getAttribute("data-open-label");
    const closeTranslation = toggle.getAttribute("data-close-label");
    if (toggle.classList.contains("is-active")) {
      toggle.setAttribute("aria-label", closeTranslation);
      toggle.setAttribute("aria-expanded", "true");
    } else {
      toggle.setAttribute("aria-label", openTranslation);
      toggle.setAttribute("aria-expanded", "false");
    }

    // toggle the display of the submenu
    $subMenu.classList.toggle("visible");
    if ($subMenu.classList.contains("visible")) {
      $subMenu.setAttribute("aria-hidden", "false");
    } else {
      $subMenu.setAttribute("aria-hidden", "true");
    }
  });
});

// handle aria attributes for the footer header buttons
const $footerHeaderButtons = document.querySelectorAll("[data-header]");
$footerHeaderButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const openLabel = button.getAttribute("data-open-label") ?? "Open";
    const closeLabel = button.getAttribute("data-close-label") ?? "Close";

    setTimeout(() => {
      const isOpen = button.classList.contains("open");

      if (isOpen) {
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("aria-label", closeLabel);
      } else {
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-label", openLabel);
      }
    }, 0);
  });
});

// handle custom video controls
const $videoControls = document.querySelectorAll(".video-controls");
$videoControls.forEach((item) => {
  const $parent = item.parentElement;
  if (!$parent) {
    return;
  }
  const $video = $parent.querySelector("video");
  if (!$video) {
    return;
  }

  item.addEventListener("click", () => {
    if (!$video.paused) {
      $video.pause();
      item.ariaLabel = `${item.dataset.play} video`;
      item.classList.add("is-paused");
      item.classList.remove("is-playing");
    } else {
      $video.play();
      item.ariaLabel = `${item.dataset.pause} video`;
      item.classList.add("is-playing");
      item.classList.remove("is-paused");
    }
    item.querySelectorAll(".icon-play, .icon-pause").forEach((icon) => {
      console.log("asdf icon", icon);
      if (icon.ariaHidden === "true") {
        icon.ariaHidden = "false";
      } else {
        icon.ariaHidden = "true";
      }
    });
  });
});

